'use client';

import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PropsWithClassname } from '@/app/types';
import { Routes } from '@/app/enums';

import Button, { ButtonHTMLTag, ButtonSize, ButtonStyle } from '@/app/components/Button/Button';
import ArrowIcon from '@/app/components/ArrowIcon/ArrowIcon';

// TODO unsure why this is necessary. During first render useTranslation fails, probably during SSR.
const useTFunction = () => {
  try {
    const i18next = useTranslation();

    return i18next.t;
  } catch (error: unknown) {
    return null;
  }
};

interface NotFoundWidgetProps extends PropsWithClassname {}

const ErrorSplash = ({ className }: NotFoundWidgetProps) => {
  const t = useTFunction();

  return (
    <div className={classNames(className, 'w-full flex justify-center')}>
      <div className="flex flex-col lg:flex-row default-page-max-width">
        <h1 className="block w-1/2 text-[32px] leading-[32px] lg:text-[48px] lg:leading-[48px] mb-[32px]">
          {t?.('components.ErrorSplash.heading')}
        </h1>
        <div className="w-1/2">
          <h2 className="text-[20px] leading-[24px] lg:text-[24px] lg:leading-[32px] mb-[16px] mb-[24px]">
            {t?.('components.ErrorSplash.text')}
          </h2>
          <div>
            <Button
              style={ButtonStyle.NEUTRAL_LINK}
              size={ButtonSize.LARGE}
              tagSpecificProps={{
                htmlTag: ButtonHTMLTag.LINK,
                href: `${process.env.NEXT_PUBLIC_REDIRECT_URL}/${Routes.ACTIVE_COLLECTIONS}`,
              }}
              className="flex items-center group"
            >
              <span className="tracking-[2px]">{t?.('components.ErrorSplash.allCollections')}</span>
              <ArrowIcon className="text-primary-mid inline mb-[2px] ml-[8px] group-hover:ml-[12px] transition-all" />
            </Button>
            <Button
              style={ButtonStyle.NEUTRAL_LINK}
              size={ButtonSize.LARGE}
              tagSpecificProps={{
                htmlTag: ButtonHTMLTag.LINK,
                href: `${process.env.NEXT_PUBLIC_REDIRECT_URL}/${Routes.CONTACT}`,
              }}
              className="flex items-center group"
            >
              <span className="tracking-[2px]">{t?.('components.ErrorSplash.contact')}</span>
              <ArrowIcon className="text-primary-mid inline mb-[2px] ml-[8px] group-hover:ml-[12px] transition-all" />
            </Button>
            <Button
              style={ButtonStyle.NEUTRAL_LINK}
              size={ButtonSize.LARGE}
              tagSpecificProps={{
                htmlTag: ButtonHTMLTag.LINK,
                href: `${process.env.NEXT_PUBLIC_REDIRECT_URL}`,
              }}
              className="flex items-center group"
            >
              <span className="tracking-[2px]">{t?.('components.ErrorSplash.homepage')}</span>
              <ArrowIcon className="text-primary-mid inline mb-[2px] ml-[8px] group-hover:ml-[12px] transition-all" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorSplash;
